
// import React, { useState } from "react";
// import styles from "./HighlightList.module.css";

// function ProjectCarousel({ images = [] }) {
//   const validImages = images.filter(Boolean);

//   const [current, setCurrent] = useState(0);

//   if (validImages.length === 0) return null;

//   const nextSlide = () => {
//     setCurrent((prev) =>
//       prev === validImages.length - 1 ? 0 : prev + 1
//     );
//   };

//   const prevSlide = () => {
//     setCurrent((prev) =>
//       prev === 0 ? validImages.length - 1 : prev - 1
//     );
//   };

//   return (
//     <div className={styles.carousel}>
//       <img
//         src={validImages[current]}
//         alt=""
//         className={styles.carouselImage}
//       />

//       {validImages.length > 1 && (
//         <>
//           <button
//             className={styles.prevBtn}
//             onClick={prevSlide}
//           >
//             ←
//           </button>

//           <button
//             className={styles.nextBtn}
//             onClick={nextSlide}
//           >
//             →
//           </button>
//         </>
//       )}
//     </div>
//   );
// }
// function HighlightList({ data, isOpen, onClose }) {
//   if (!isOpen || !data) return null;

//   return (
//     <div className={styles.overlay}>
//       <div className={styles.container}>
        
//         <button
//           className={styles.closeBtn}
//           onClick={onClose}
//         >
//           ×
//         </button>
//         {/* PROJECTS */}
//         <div className={styles.projectsWrapper}>
//           {data.projects.map((project) => (
//             <div
//               key={project.id}
//               className={styles.projectRow}
//             >
//               {/* LEFT */}
//               <div className={styles.left}>
//                 <h3 className={styles.title}>
//                   {project.title}
//                 </h3>

//                 <p className={styles.description}>
//                   {project.description}
//                 </p>

//               </div>

//               {/* RIGHT */}
//               <div className={styles.right}>
//                 <ProjectCarousel
//                   images={project.images}
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default HighlightList;



import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import styles from "./HighlightList.module.css";

function ProjectCarousel({ images = [] }) {
  const validImages = images.filter(Boolean);

  const [current, setCurrent] = useState(0);

  if (validImages.length === 0) return null;

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === validImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? validImages.length - 1 : prev - 1
    );
  };

  return (
    <div className={styles.carousel}>
      <img
        src={validImages[current]}
        alt=""
        className={styles.carouselImage}
      />

      {validImages.length > 1 && (
        <>
       
<button className={styles.prevBtn} onClick={prevSlide}>
  <FiChevronLeft />
</button>

<button className={styles.nextBtn} onClick={nextSlide}>
  <FiChevronRight />
</button>
        </>
      )}
    </div>
  );
}
function HighlightList({ data, isOpen, onClose }) {
  if (!isOpen || !data) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        
        <button
          className={styles.closeBtn}
          onClick={onClose}
        >
          ×
        </button>
        {/* PROJECTS */}
        <div className={styles.projectsWrapper}>
          {data.projects.map((project) => (
            <div
              key={project.id}
              className={styles.projectRow}
            >
              {/* LEFT */}
              <div className={styles.left}>
                <h3 className={styles.title}>
                  {project.title}
                </h3>

                <p className={styles.description}>
                  {project.description}
                </p>

              </div>

              {/* RIGHT */}
              <div className={styles.right}>
                <ProjectCarousel
                  images={project.images}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HighlightList;